export default __webpack_public_path__ + "static/media/background2.cf5fcf63.jpg";